import { AsyncAction } from 'src/utils/reduxUtils'
import { ApiService, callClientSecureApi } from './api/callApi'
import { call, put, takeLatest } from 'redux-saga/effects'
import { Endpoints } from 'src/constants/endpoints'
import { getApiErrorMessage } from 'src/utils/errorHandlers'
import { FetchDriver, UploadDebitCard } from 'src/constants/actionTypes'
import {
  PaymentMethodRecipientNamePreference,
  PaymentMethodTypeEnum,
} from 'src/interfaces/paymentMethod'

interface DebitCardRequest {
  cardNumber: string
  cardExpiration: string
  zipcode: string
  stepId: string
  recipientNamePreference: PaymentMethodRecipientNamePreference
}

function* onUploadDebitCard(action: AsyncAction<DebitCardRequest>) {
  const { cardNumber, cardExpiration, stepId, zipcode, recipientNamePreference } = action.payload

  try {
    yield call(callClientSecureApi, Endpoints.UploadPaymentMethod, {
      method: 'POST',
      body: {
        stepId,
        paymentMethodType: PaymentMethodTypeEnum.Card,
        recipientNamePreference,
        cardDetails: {
          cardNumber,
          cardExpiration,
          zipcode,
        },
      },
      apiService: ApiService.Paraworks,
    })

    yield put(UploadDebitCard.success())

    yield put(FetchDriver.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    const errorMessage = getApiErrorMessage(err, 'Failed to upload debit card')

    yield put(UploadDebitCard.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* debitCardSaga() {
  yield takeLatest(UploadDebitCard.type.REQUEST, onUploadDebitCard)
}
